import React from 'react'
import PropTypes from 'prop-types'

function Container({ children, className }) {
  return <div className={`w-full px-4 lg:px-0 lg:w-3/4 lg:mx-auto ${className}`}>{children}</div>
}

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export { Container }
